import { render, staticRenderFns } from "./operateRecord.vue?vue&type=template&id=19859be2&scoped=true"
import script from "./operateRecord.vue?vue&type=script&lang=js"
export * from "./operateRecord.vue?vue&type=script&lang=js"
import style0 from "./operateRecord.vue?vue&type=style&index=0&id=19859be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19859be2",
  null
  
)

export default component.exports